import { SimpleProjectile } from "./simpleProjectile";
import type { XY } from "./xy";

export abstract class ProjectileWithMaxRange extends SimpleProjectile {
	travelledDistance: number = 0;

	protected moveTo(destination: XY): boolean {
		const moved = super.moveTo(destination);
		if (moved) this.travelledDistance++;
		if (this.active && this.travelledDistance >= this.getMaxRange()) {
			this.onReachingMaxRange();
		}
		return moved;
	}

	abstract getMaxRange(): number;
	abstract onReachingMaxRange(): void;

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), travelledDistance: this.travelledDistance };
	}
}
